export const StringUtils = {
  formatDateOfBirth(date) {
    if (!date) return '';
    //10/28/1966-{dobmonth}-10/28/1966
    if (String(date).includes('-{dobmonth}-')) {
      const s = String(date).split('-{dobmonth}-');
      date = s[0];

      if (date.length === 10) {
        // It's in MM/DD/YYYY format, rearrange to YYYY-MM-DD
        const parts = date.split('/');
        return `${parts[2]}-${parts[0]}-${parts[1]}`;
      }
    }

    const getSplitIdentifier = date.indexOf('-') > -1 ? '-' : '/';
    const parts = date.split(getSplitIdentifier);
    if (parts.length === 3 && parts[2].length === 4) {
      // It's in DD-MM-YYYY format, rearrange to YYYY-MM-DD
      console.log('should be returned', `${parts[2]}-${parts[1]}-${parts[0]}`)
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }

    // Return the original date if it doesn't match expected formats
    return date;
  }
}
